exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-bread[data-v-65507a64]{margin-top:8px;margin-left:10px;font-size:20px;font-weight:700}", ""]);

// exports
